import script from "./status-pie-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./status-pie-chart.vue?vue&type=script&lang=ts&setup=true"

import "./status-pie-chart.vue?vue&type=style&index=0&id=6bfa308b&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bfa308b"]])

export default __exports__